import { useContext } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { AuthContext, Logo, ViewContext, useLocation } from "@/components/lib";
import Styles from "@/css/mainStyles";

export function ResetPassword() {
  // context
  const location = useLocation();
  const context = useContext(AuthContext);
  const viewContext = useContext<any>(ViewContext);

  // check for token
  const qs = location.search;
  const token = qs.substring(qs.indexOf("?token=") + 7);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    try {
      const res = await axios({
        method: "post",
        url: "/api/auth/password/reset",
        data: { jwt: token, email: data.email, password: data.password }
      });
      context.signin(res);
    } catch (error) {
      console.error(error);
      let message = error.response?.data ? error.response.data : error.message;
      if (
        message === "Validation Error in body" &&
        error.response.data?.errors?.[0]?.message
      ) {
        message = error.response.data.errors[0].message;
      }
      viewContext.notification.show(message, "error");
    }
  };

  return (
    <div className="flex flex-col justify-center h-screen p-8 md:px-32 text-left lg:w-1/2">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl text-center">
        Reset Your Password
      </h1>
      <form
        className="flex flex-col gap-6 mt-7 text-left"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Email</label>
          <input
            placeholder="Enter Email"
            type="email"
            className={Styles.input}
            {...register("email", { required: true })}
            style={errors.email && { border: "1px solid red" }}
          />
          {errors.email && <p className={Styles.error}>Email is required</p>}
        </div>
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>New Password</label>
          <input
            placeholder="Enter Password"
            type="password"
            className={Styles.input}
            {...register("password", { required: true })}
            style={errors.password && { border: "1px solid red" }}
          />
          {errors.password && (
            <p className={Styles.error}>Password is required</p>
          )}
        </div>
        <input
          type="submit"
          value="Set New Password"
          className={Styles.submitButton}
        />
      </form>
    </div>
  );
}
